// @flow
import * as React from 'react';
import path from 'ramda/es/path';

import { applyStyles } from 'app/common/lib/styles';


const dragStyles = {
  cursor: 'grab',
  'user-select': 'none',
  '-moz-user-select': 'none',
  '-webkit-user-select': 'none',
  '-ms-user-select': 'none',
};

const defStyles = {
  cursor: 'auto',
  'user-select': 'auto',
  '-moz-user-select': 'auto',
  '-webkit-user-select': 'auto',
  '-ms-user-select': 'auto',
};

type RefFunc = (el: React.ElementRef<any> | null) => void;

type Props = {
  children: (RefFunc) => React.Node,
  reference?: RefFunc,
  refPath?: Array<string>,
};

type State = {
  pushed: boolean,
}

class ScrollByDrag extends React.Component<Props, State> {
  state = {
    pushed: false,
  };

  handleMouseDown = (e: SyntheticMouseEvent<HTMLElement>) => {
    this.setState({ pushed: true });
    this.lastClientX = e.clientX;
    this.lastClientY = e.clientY;
    if (this.element) {
      applyStyles(this.element, dragStyles);
    }
  };

  handleMouseUp = () => {
    this.setState({ pushed: false });
    if (this.element) {
      applyStyles(this.element, defStyles);
    }
  };

  handleMouseMove = (e: SyntheticMouseEvent<HTMLElement>) => {
    const { pushed } = this.state;
    if (pushed && this.element) {
      const { clientX, clientY } = e;
      this.element.scrollLeft -= clientX - this.lastClientX;
      this.element.scrollTop -= clientY - this.lastClientY;
      this.lastClientX = clientX;
      this.lastClientY = clientY;
      e.stopPropagation();
      e.preventDefault();
    }
  };

  handleReference = (el: React.ElementRef<any> | null) => {
    const { reference, refPath } = this.props;
    if (typeof reference === 'function') {
      reference(el);
    }
    if (!el) {
      window.removeEventListener('mouseup', this.handleMouseUp);
      window.addEventListener('mousemove', this.handleMouseMove);
      return;
    }
    this.element = refPath ? path(refPath, el) : el;
    this.element.addEventListener('mousedown', this.handleMouseDown);
    window.addEventListener('mouseup', this.handleMouseUp);
    window.addEventListener('mousemove', this.handleMouseMove);
  };

  element: React.ElementRef<any> | null;

  lastClientX: number;

  lastClientY: number;

  render() {
    const { children } = this.props;
    return (typeof children === 'function'
      ? children(this.handleReference)
      : <div>{'ScrollByDrag -- children must be function'}</div>);
  }
}

export default ScrollByDrag;
